// extracted by mini-css-extract-plugin
export default {"sidebarData":"Sidebar_sidebarData__C-89J","sidebarDescription":"Sidebar_sidebarDescription__lhAjM","sidebarLabel":"Sidebar_sidebarLabel__5J6Uk"};